var Spinner = {
  show: function(){
    var element = document.getElementById('js-ajax-spinner');

    if(element){
      element.style.display = 'block';
    }
  },
  hide: function(){
    var element = document.getElementById('js-ajax-spinner');
    if(element){
      element.style.display = 'none';
    }
  }
}

var apiCaller = function(config){
  var url;
  if(!config.url){
    var baseUrl = "/web_api/parent/v1";
    if(typeof(config.baseUrl) == "string") {
      baseUrl = config.baseUrl;
    }
    url = baseUrl + config.path;
  }else{
    url = config.url;
  }
  var methodType = config.method || 'get';
  var params = config.params || {};

  var successCallback = config.callback;
  var errorCallback = config.errorCallback || function(){};

  function status(response) {
    if (response.status >= 200 && response.status < 300) {
      return Promise.resolve(response)
    } else {
      // user is logged out.
      if(response.status == 401){
        window.location = '/';
      } else if(params.rejectWithErrorObject){
        return response.json().then( resp=> Promise.reject(resp))
      } else{
        return Promise.reject(new Error(response.statusText))
      }
    }
  }

  function json(response) {
    return response.json()
  }

  var requestConfig = {
    method: methodType,
    credentials: "same-origin",
    headers: {
      "Content-type": "application/json; charset=UTF-8",
      "X-Requested-With": "XMLHttpRequest"
    }
  }

  if(methodType != 'get'){
    requestConfig.headers['X-CSRF-Token'] = $('[name=csrf-token]').attr('content')
  }

  if(methodType != 'get' && !!params){
    requestConfig.body = JSON.stringify(params);
  }

  if(methodType == 'get' && !!params){
    const esc = encodeURIComponent;
    var query = Object.keys(params).map(k => esc(k) + '=' + esc(params[k])).join('&');
    url += "?" + query;
  }
  if (!config.dontShowAjaxSpinner)
    Spinner.show();

  fetch(url, requestConfig)
    .then(status)
    .then(json)
    .then(function(data){
      Spinner.hide();
      successCallback && successCallback(data)
    })
    .catch(function(error){
      Spinner.hide();
      console.error('Error:',error);
      errorCallback && errorCallback(error);
    });
}

export const apiCallerWithPromise = (opts) => {
  return new Promise((resolve, reject) => {
    apiCaller({...opts, callback: resolve, errorCallback: reject})
  })
}
export const GlobalSpinner = Spinner;
export default apiCaller;

